import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { InterviewBlock } from '@features/enterpriseEvents';
import { useDeleteCalendarBlock } from '@features/enterpriseEvents/hooks/useDeleteCalendarBlock';
import CloseIcon from '@mui/icons-material/Close';
import { DeleteIcon, OpenInterview } from '../../../../vectors/index';
import { Delete } from '@mui/icons-material';

type DeleteCalendarBlockModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  onSuccess: () => void;
  calendarBlock: InterviewBlock;
  handlePageNo?: (newPageNo: number) => void;
};

const DeleteCalendarBlockModal: FC<DeleteCalendarBlockModalProps> = ({
  isOpen,
  handleClose,
  onSuccess,
  calendarBlock,
  handlePageNo
}) => {
  const [errorText, setErrorText] = useState('');
  const [interviewBlockStartTime, setInterviewBlockStartTime] = useState(
    dayjs(calendarBlock?.dt_start_time).valueOf() / 1000,
  );

  const { deleteCalendarBlock, isDeletingCalendarBlock } =
    useDeleteCalendarBlock({
      setErrorText,
      interviewBlockStartTime,
    });

  const handleDelete = () =>
    deleteCalendarBlock(
      { calendar_block_id: calendarBlock.id },
      {
        onSuccess: (data) => {
          if (data.status === 200) {
            toast.success('Calendar Block Deleted');
            onSuccess();
            handleClose();
            if (handlePageNo) {
              handlePageNo(1)
            }

          }
        },
      },
    );

  useEffect(() => {
    if (calendarBlock) {
      setInterviewBlockStartTime(
        dayjs(calendarBlock?.dt_start_time).valueOf() / 1000,
      );
    }
  }, [calendarBlock]);

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <br />
        <DeleteIcon />
        <br />
        <Typography variant="h4" sx={{ p: 3 }}>
          Delete Calendar Block
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ marginBottom: 3 }}>
          {errorText && <Alert severity="error">{errorText}</Alert>}
          <Typography textAlign="center">
            Are you sure you want to delete this event? Applicants who have
            confirmed this interview will be reverted to their previous status
            and will need to be re-invited to interview.
          </Typography>
          <LoadingButton
            variant="contained"
            loading={isDeletingCalendarBlock}
            onClick={handleDelete}
            color="error"
            startIcon={<Delete/>}
          >
            Yes, delete this calendar block
          </LoadingButton>
          <Button
            startIcon={<CloseIcon />}
            color="secondary"
            variant="outlined"
            onClick={handleClose}
          >
            No, Go Back
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteCalendarBlockModal;
